import { ComponentProps, ReactNode } from 'react';
import { DropdownMenuOption } from '../../types';
import setDenaliAttribute from '../../utils/setDenaliAttribute';
import Popover from '../Popover/Popover';
import DropdownMenuItems from './DropdownMenuItems';

type DropdownMenuProps = Pick<
  ComponentProps<typeof Popover>,
  'anchor' | 'className' | 'containerMouseHandlers' | 'isOpen' | 'onCloseRequest' | 'placement' | 'returnFocusOnDeactivate' | 'usePortal'
> & {
  children?: ReactNode;
  options: DropdownMenuOption[];
  scrollSelectedIntoView?: boolean;
  scrollToIndex?: number;
  textVariant?: 'text100' | 'text200';
};

const DropdownMenu = ({ children, options, scrollSelectedIntoView, scrollToIndex, textVariant, ...popoverProps }: DropdownMenuProps) => (
  <Popover {...setDenaliAttribute('DropdownMenu')} {...popoverProps}>
    <DropdownMenuItems
      className={popoverProps.className}
      options={options}
      scrollSelectedIntoView={scrollSelectedIntoView}
      scrollToIndex={scrollToIndex}
      textVariant={textVariant}
    >
      {children}
    </DropdownMenuItems>
  </Popover>
);

export default DropdownMenu;
